export default "__VITE_ASSET__BHh38guU__"